var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 748,
    viewBox: "0 0 615 748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1103.1 1208.7C1028.06 1128.59 1016.73 1111.84 972.915 1034.24C962.18 1015.23 946.175 978.954 932.189 934.946C927.995 921.775 924.337 908.784 921.102 896.026C898.065 804.744 906.564 707.246 927.985 612.767C982.648 371.707 881.179 133.194 690.166 41.2414C498.823 -50.8622 261.74 24.0143 130.3 173.987C113.199 193.501 36.8445 286.19 12.1962 396.096C-65.7244 743.094 254.842 930.597 757.499 1108.67C767.278 1112.12 814.108 1126.64 824.08 1129.45L1103.13 1208.74L1103.1 1208.7Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape5.e02d7b028536d6a8e95ac44fff79f8b0.svg";
export { ForwardRef as ReactComponent };